<template>
  <div class="trip-details">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-left">
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              @click="callBackRoute"
              v-bind="attrs"
              v-on="on"
              class="mr-3"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
        <h2 class="trip-title">Trip Details - {{ tripDetails.trip_id }}</h2>
        <span class="status-chip" :class="getStatusClass(tripDetails.status)">
          {{ tripDetails.status }}
        </span>
        <v-menu open-on-hover right offset-y v-if="tripDetails">
          <template v-slot:activator="{ on, attrs }">
            <button
              class="icon-btn"
              title="Route Address"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon class="mr-1" color="red">mdi-map-marker-distance</v-icon>
              <span style="color: red">Route Address</span>
            </button>
          </template>
          <v-card>
            <v-card-title
              class="secondary white--text text-subtitle-1 font-weight-medium py-1"
            >
              Route Address
            </v-card-title>
            <v-card-text class="mt-2">
              <table class="Normal-Table">
                <tbody>
                  <tr v-if="tripDetails.source_location_name">
                    <th>Source Location</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.source_location_name }}</td>
                  </tr>
                  <tr v-if="tripDetails.mid_location_name">
                    <th>Mid Point Location</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.mid_location_name }}</td>
                  </tr>
                  <tr v-if="tripDetails.destination_location_name">
                    <th>Destination Location</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.destination_location_name }}</td>
                  </tr>
                  <tr v-if="tripDetails.source_address">
                    <th>Source Address</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.source_address }}</td>
                  </tr>
                  <tr v-if="tripDetails.mid_address">
                    <th>Mid Point Address</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.mid_address }}</td>
                  </tr>
                  <tr v-if="tripDetails.destination_address">
                    <th>Destination Address</th>
                    <th class="px-2">:</th>
                    <td>{{ tripDetails.destination_address }}</td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-menu
          open-on-hover
          right
          offset-y
          v-if="tripDetails.trip_leg_containers"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              class="icon-btn"
              title="Container Information"
              v-on="on"
              v-bind="attrs"
            >
              <v-icon class="mr-1" color="success"
                >mdi-train-car-container</v-icon
              >
              <span class="text-success">Container Info</span>

              <!-- <span class="badge">{{ tripDetails.container_count }}</span> -->
            </button>
          </template>

          <v-card>
            <v-card-title
              class="secondary white--text text-subtitle-1 font-weight-medium py-1"
            >
              Container Information
            </v-card-title>
            <v-card-text class="mt-2">
              <v-row>
                <v-col
                  cols="12"
                  v-for="(container, i) in tripDetails.trip_leg_containers"
                  :key="i"
                >
                  <ContainerCard
                    :container="container"
                    :showAddressDetails="false"
                    :isTransporter="true"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-menu>

        <div class="navigation-btns">
          <button
            class="nav-btn"
            @click="getNextPreviousTrip('previous')"
            title="Previous"
          >
            <span>⮜</span>
          </button>
          <button
            class="nav-btn"
            @click="getNextPreviousTrip('next')"
            title="Next"
          >
            <span>⮞</span>
          </button>
        </div>
      </div>
      <div class="header-right">
        <v-btn
          v-if="
            tripDetails.status == 'Assigned' &&
            tripDetails.is_checklist_passed == 'No'
          "
          class="primary-btn"
          color="blue"
          small
          @click="openChecklist"
        >
          <v-icon left>mdi-format-list-checks</v-icon>
          {{
            tripDetails.is_checklist_submitted === "Yes"
              ? "Defect Checklist"
              : "Checklist"
          }}
        </v-btn>
        <v-btn
          v-if="tripDetails.status == 'Assigned'"
          class="upload-btn"
          color="purple"
          title="Start Trip"
          small
          @click="startTrip"
        >
          <v-icon left>mdi-car-arrow-right</v-icon>
          Start Trip
        </v-btn>
        <v-btn
          v-if="
            tripDetails.is_trip_all_milestone_completed &&
            tripDetails.status != 'Completed'
          "
          class="upload-btn"
          color="success"
          small
          title="Complete Trip"
          @click="startTrip"
        >
          <v-icon left>mdi-car-arrow-right</v-icon>
          Complete Trip
        </v-btn>
        <v-btn
          class="primary-btn"
          color="secondary"
          small
          @click="showLegDialog = true"
        >
          <v-icon left>mdi-truck-delivery</v-icon>
          Legs
        </v-btn>
        <v-btn
          class="primary-btn"
          color="primary"
          small
          @click="$bus.$emit('openTripChat', tripDetails.id)"
        >
          <v-icon left>mdi-chat</v-icon>
          Open Chat
        </v-btn>

        <v-btn color="primary" small class="primary-btn" @click="showLogs">
          <v-icon left>mdi-history</v-icon>
          Logs
        </v-btn>
        <v-btn
          v-if="
            tripDetails.status === 'Completed' ||
            tripDetails.status === 'Active'
          "
          color="primary"
          small
          class="primary-btn"
          @click="viewCheckListDialog()"
        >
          <v-icon class="pl-2">mdi-format-list-checks</v-icon>

          View CheckList
        </v-btn>
        <v-btn
        color="primary"
        depressed
        :disabled="tripDetails.status == 'Completed'"
        @click="addEwaybilldoc()"
      >
        Upload Doc
      </v-btn>
      </div>
    </div>

    <!-- Trip Info Section -->
    <!-- Replace your current trip-info-section with this -->
    <div class="trip-info-section-table">
      <table class="trip-info-table">
        <thead>
          <tr>
            <th>Source Location</th>
            <th v-if="tripDetails.mid_location_code">Mid Location</th>
            <th v-if="tripDetails.destination_location_code">
              Destination Location
            </th>
            <th>Trip Date</th>
            <th>Est Start Date & Time</th>
            <th>Est. End Date & Time</th>
            <th>Driver Name</th>
            <th>Vehicle</th>
            <th>Trailer</th>

            <th>Depot</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ tripDetails.source_location_code }}</td>
            <td v-if="tripDetails.mid_location_code">
              {{ tripDetails.mid_location_code }}
            </td>
            <td v-if="tripDetails.destination_location_code">
              {{ tripDetails.destination_location_code }}
            </td>
            <td>{{ tripDetails.trip_date }}</td>
            <td>{{ tripDetails.est_start_date_and_time }}</td>
            <td>{{ tripDetails.est_end_date_and_time }}</td>
            <td class="">
              <span
                class="font-weight-bold mouse"
                style="cursor: pointer"
                :style="{
                  color:
                    tripDetails.driver_status === 'Active' ? 'green' : 'orange',
                }"
                @click="goToDriverList()"
              >
                {{ tripDetails.driver_name || "N/A" }}
              </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    size="18"
                    color="info"
                    class="ml-1 cursor-pointer"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <div>
                  <div>
                    <strong>Status:</strong>
                    {{ tripDetails.driver_status || "N/A" }}
                  </div>
                  <div>
                    <strong>Next Availability:</strong>
                    {{
                      formatDateTime(tripDetails.driver_next_availability) ||
                      "N/A"
                    }}
                  </div>
                </div>
              </v-tooltip>
            </td>

            <td>
              <span
                class="font-weight-bold mouse"
                style="cursor: pointer"
                :style="{
                  color: 'orange',
                }"
                @click="goToVehicleList()"
              >
                {{ tripDetails.vehicle_number || "N/A" }}
              </span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    size="18"
                    color="info"
                    class="ml-1 cursor-pointer"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <div>
                  <div>
                    <strong>Status:</strong>
                    {{ tripDetails.vehicle_status || "N/A" }}
                  </div>
                  <div>
                    <strong>Next Availability:</strong>
                    {{
                      formatDateTime(tripDetails.vehicle_next_availability) ||
                      "N/A"
                    }}
                  </div>
                </div>
              </v-tooltip>
            </td>
            <td>
              <span
                class="font-weight-bold mouse"
                style="cursor: pointer"
                :style="{
                  color: 'orange',
                }"
                @click="goToTrailerList()"
              >
                {{ tripDetails.trailer_1_number || "N/A" }}
              </span>
            </td>

            <td>{{ tripDetails.depot || "N/A" }}</td>
          </tr>
        </tbody>
      </table>

      <table class="trip-info-table" style="margin-top: 20px">
        <thead>
          <tr>
            <th v-if="tripDetails.status !== 'Completed'">
              CheckList Submitted
            </th>
            <th v-if="tripDetails.status !== 'Completed'">CheckList Passed</th>
            <th>Actual Trip Start</th>
            <th>Actual Trip End</th>
            <th>Vehicle Odometer</th>
            <th>Trip Start KM</th>
            <th>Trip End KM</th>
            <th>Channel</th>
            <th>Buffer Time(in Mins)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-if="tripDetails.status !== 'Completed'">
              <v-chip
                class="ml-5"
                v-if="tripDetails.is_checklist_submitted === 'Yes'"
                color="success"
                text-color="white"
                label
                small
              >
                {{ tripDetails.is_checklist_submitted }}
              </v-chip>
              <v-chip v-else color="red" text-color="white" label small>
                {{ tripDetails.is_checklist_submitted }}
              </v-chip>
            </td>
            <td v-if="tripDetails.status !== 'Completed'">
              <v-chip
                class="ml-5"
                v-if="tripDetails.is_checklist_passed === 'Yes'"
                color="success"
                text-color="white"
                label
                small
              >
                {{ tripDetails.is_checklist_passed }}
              </v-chip>
              <v-chip v-else color="red" text-color="white" label small>
                {{ tripDetails.is_checklist_passed }}
              </v-chip>
            </td>
            <td>
              {{
                tripDetails.trip_start
                  ? formatDateTime(tripDetails.trip_start)
                  : "N/A"
              }}
              <button
                v-if="
                  tripDetails.trip_start && tripDetails.status == 'Completed'
                "
                class="edit-btn"
                @click="editTripStartTimestamp"
              >
                ✏️
              </button>
            </td>
            <td>
              {{
                tripDetails.trip_end
                  ? formatDateTime(tripDetails.trip_end)
                  : "N/A"
              }}
              <button
                v-if="tripDetails.trip_end && tripDetails.status == 'Completed'"
                class="edit-btn"
                @click="editTripEndTimestamp"
              >
                ✏️
              </button>
            </td>
            <td>{{ tripDetails.vehicle_odometer_reading }}</td>
            <td>{{ tripDetails.trip_start_km }}</td>
            <td>
              {{ tripDetails.trip_end_km || "N/A" }}
              <button
                v-if="tripDetails.status === 'Completed'"
                class="edit-btn"
                @click="editOdometerKm"
              >
                ✏️
              </button>
            </td>

            <td>{{ tripDetails.completion_agent || "N/A" }}</td>

            <td>{{ tripDetails.buffer_time || "N/A" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Main Content Section -->
    <div class="main-content">
      <!-- Map Section -->
      <div class="map-section">
        <div class="map-header">
          <h3>Route Map</h3>
          <div class="map-legend">
            <div class="legend-item">
              <span class="legend-dot start"></span>
              <span>Start Location</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot end"></span>
              <span>End Location</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot current"></span>
              <span>Current Location</span>
            </div>
          </div>
        </div>
        <div class="map-container">
          <div class="map-placeholder">
            <GoogleMap
              ref="transporterTripDetailsMap"
              mapHeight="calc(110vh - 200px)"
              mapWidth="100%"
              :hasMapInfo="true"
            >
              <template #mapInfo>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="d-flex align-center pa-2">
                      <img style="width: 18px" :src="sourceMarker" />
                      <span class="ml-4 text-body-2 font-weight-bold">
                        Source
                      </span>
                    </v-col>

                    <v-col cols="12" class="d-flex align-center pa-2">
                      <img style="width: 18px" :src="midMarker" />
                      <span class="ml-4 text-body-2 font-weight-bold">
                        Mid
                      </span>
                    </v-col>

                    <v-col cols="12" class="d-flex align-center pa-2">
                      <img style="width: 18px" :src="destinationMarker" />
                      <span class="ml-4 text-body-2 font-weight-bold">
                        Destination
                      </span>
                    </v-col>
                    <v-col cols="12" class="d-flex align-center pa-2">
                      <img style="width: 18px" :src="truckMarker" />
                      <span class="ml-4 text-body-2 font-weight-bold">
                        Vehicle
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </template>
            </GoogleMap>
          </div>
        </div>
      </div>

      <div class="milestones-section">
        <h4 class="milestones-title">Trip Milestones</h4>
        <div class="leg-selection">
          <div class="leg-header">
            <!-- <span class="leg-progress-text">{{ completedMilestones }}/{{ totalMilestones }}</span> -->
          </div>

          <MultiSelect
            hide-details="auto"
            label="Select Leg"
            placeholder="Select Leg"
            :items="triplegs"
            item-text="leg_id"
            item-value="id"
            v-model="selectedLegId"
            @change="onLegChange"
          />
        </div>

        <div class="milestones-list">
          <div v-if="selectedLeg" class="milestones-list">
            <h3 class="pl-2">
              Milestones for {{ selectedLeg.leg_id }} - {{ selectedLeg.title }}
            </h3>

            <div
              v-for="(milestone, index) in selectedLeg.trip_milestones"
              :key="index"
              class="milestone-item mt-2"
            >
              <div class="milestone-checkbox">
                <template v-if="tripDetails.status !== 'Assigned'">
                  <input
                    type="checkbox"
                    :id="`milestone-${index}`"
                    v-model="milestone.is_updated"
                    @click="
                      updateMilestone(
                        milestone.id,
                        milestone.trip,
                        milestone.timestamp,
                        milestone.name,
                      )
                    "
                    class="custom-checkbox"
                    :disabled="milestone.is_updated"
                  />
                  <label
                    :for="`milestone-${index}`"
                    class="checkbox-label"
                  ></label>
                </template>

                <v-tooltip v-else bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="primary"
                      small
                      v-bind="attrs"
                      v-on="on"
                      class="ml-2"
                    >
                      mdi-information
                    </v-icon>
                  </template>
                  <span>Trip is in assigned stage</span>
                </v-tooltip>
              </div>

              <div class="milestone-content">
                <div class="milestone-header">
                  <span class="milestone-icon">📍</span>
                  <strong>{{ milestone.name }}</strong>
                  <v-tooltip bottom v-if="milestone.is_updated">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        color="orange"
                        class="ml-4"
                        small
                      >
                        mdi-speedometer
                      </v-icon>
                    </template>
                    <span
                      >Odometer Reading:
                      {{ milestone.odometer_reading || "N/A" }}</span
                    >
                  </v-tooltip>
                  <span class="milestone-time">{{ milestone.timestamp }}</span>
                </div>
                <p class="milestone-description">{{ milestone.description }}</p>
              </div>

              <v-tooltip
                bottom
                v-if="
                  tripDetails.status === 'Active' ||
                  tripDetails.status === 'Completed'
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- Wrap icon inside span -->
                  <span v-bind="attrs" v-on="on">
                    <v-icon
                      color="info"
                      :disabled="
                        tripDetails.is_ready_for_invoice ||
                        tripDetails.sap_bonus_payout_created
                      "
                      @click="
                        !isRevertDisabled &&
                          revertTrip(milestone.id, milestone.sequence)
                      "
                    >
                      mdi-arrow-u-left-top-bold
                    </v-icon>
                  </span>
                </template>

                <span v-if="tripDetails.is_ready_for_invoice">
                  Trip invoice has already been generated.
                </span>
                <span v-else-if="tripDetails.sap_bonus_payout_created">
                  Bonus payout has already been generated for this trip.
                </span>
                <span v-else> Revert Milestone </span>
              </v-tooltip>
            </div>
          </div>
        </div>
      </div>
      <TriptimeStampDialog
        v-model="tripTimeStampDialog"
        :tripID="tripDetails.id"
        @refreshList="refreshTripDetails()"
      />
      <TripEndtimeStampDialog
        v-model="tripendTimeStampDialog"
        :tripID="tripDetails.id"
        @refreshList="refreshTripDetails()"
      />
      <TripOdometerEditDialog
        v-model="tripOdometerEditDialog"
        :tripID="tripDetails.id"
        @refreshList="refreshTripDetails()"
      />
      <TripOdometerDialog
        v-model="showOdometerDialog"
        :IsAllMilestoneComplete="tripDetails.is_trip_all_milestone_completed"
        :tripDetails="tripDetails"
        @refreshList="refreshTripDetails()"
      />

      <ViewCheckListDialog
        v-model="viewCheckList"
        :tripDetails="tripDetails"
        @refreshList="refreshTripDetails()"
      />

      <TripLogsDialog
        v-model="showTripLogs"
        :tripDetails="tripDetails"
        @refreshList="refreshTripDetails()"
      />

      <TripChecklistDialog
        v-model="showTripChecklistForm"
        :tripDetails="tripDetails"
        :checkList="checkList"
        :defectchecklist="defectCheckList"
        :SubmittedCheckListData="SubmittedCheckListData"
        @refreshList="refreshTripDetails()"
      />

      <TripLegsDialog
        v-model="showLegDialog"
        :tripDetails="tripDetails"
        @refreshList="refreshTripDetails()"
      />

      <RenewConfirmationDialogue
        v-model="showConfirmationDialog"
        :status="status"
        :title="title"
        :showRemarks="true"
        :postDate="postDate"
        :text="text"
        :icon="icon"
        @confirmed="updateTripRevertMilestone"
        @rejected="refreshCalls()"
      />
      <TripPod
         v-model="showTripPodDialog"
         :legId="selectedLegId"
      />
    </div>
  </div>
</template>

<script>
import TripOdometerDialog from "@/components/ModuleBased/dialogForms/TripOdometerDialog.vue";
import TriptimeStampDialog from "@/components/ModuleBased/dialogForms/TriptimeStampDialog.vue";
import TripEndtimeStampDialog from "@/components/ModuleBased/dialogForms/TripEndtimeStampDialog.vue";
import TripOdometerEditDialog from "@/components/ModuleBased/dialogForms/TripOdometerEditDialog.vue";
import TripLogsDialog from "@/components/ModuleBased/dialogForms/TripLogsDialog.vue";
import TripChecklistDialog from "@/components/ModuleBased/dialogForms/TripChecklistDialog.vue";
import TripLegsDialog from "@/components/ModuleBased/dialogForms/TripLegsDialog.vue";
import ContainerCard from "@/components/General/ContainerCard.vue";
import GoogleMap from "@/components/General/GoogleMap.vue";
import NewConfirmationDialog from "@/components/General/NewConfirmationDialog.vue";
import MultiSelect from "@/components/FormBaseComponents/MultiSelect.vue";
import RenewConfirmationDialogue from "@/components/General/RenewConfirmationDialogue.vue";
import ViewCheckListDialog from "@/components/ModuleBased/dialogForms/ViewCheckListDialog.vue";
import TripPod from "@/components/ModuleBased/dialogForms/TripPod.vue";

import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";
import {
  sourceMarker,
  destinationMarker,
  midMarker,
  truckMarker,
} from "@/assets/images/mapIcons.js";

export default {
  name: "TripDetails",
  components: {
    TripOdometerDialog,
    TripLegsDialog,
    TriptimeStampDialog,
    MultiSelect,
    TripEndtimeStampDialog,
    TripOdometerEditDialog,
    ContainerCard,
    TripLogsDialog,
    TripPod,
    NewConfirmationDialog,
    GoogleMap,
    TripChecklistDialog,
    RenewConfirmationDialogue,
    ViewCheckListDialog,
  },
  data() {
    return {
      sourceMarker,
      destinationMarker,
      truckMarker,
      midMarker,
      showTripPodDialog:false,
      waypoints: [],
      status: "",
      title: "",
      text: "",
      icon: "",
      postDate: "",
      waypointNames: [],
      selectedLegId: null,
      viewCheckList: false,
      triplegs: [],
      directions: [],
      directionsTimeout: null,
      selectedRoute: {},
      markerTimeout: null,
      driverLocationDetails: {},
      showConfirmationDialog: false,
      waypointNames: [],
      tripendTimeStampDialog: false,
      showTripLogs: false,
      showTripChecklistForm: false,
      tripTimeStampDialog: false,
      isCheckListSubmitted: false,
      isCheckListPassed: false,
      tripOdometerEditDialog: false,
      newStatus: null,
      showOdometerDialog: false,
      selectedMilestone: "",
      selectedLeg: null,
      dropdownOpen: false,
      availableLegs: [],
      tripDetails: {},
      milestones: [],
      checkList: [],
      defectCheckList: [],
      SubmittedCheckListData: [],
      showLegDialog: false,
    };
  },
  computed: {
    tripProgress() {
      return 75; // 75% complete based on the design
    },
    completedMilestones() {
      return this.milestones.filter((m) => m.completed).length;
    },
    totalMilestones() {
      return this.milestones.length;
    },
  },
  methods: {
    viewCheckListDialog() {
      this.viewCheckList = true;
    },
    editTripStartTimestamp() {
      this.tripTimeStampDialog = true;
    },
    editOdometerKm() {
      this.tripOdometerEditDialog = true;
    },
    startTrip() {
      this.showOdometerDialog = true;
    },

    editTripEndTimestamp() {
      this.tripendTimeStampDialog = true;
    },
    selectLeg(leg) {
      this.selectedLeg = leg;
      this.selectedLegId = leg.id;
      this.dropdownOpen = false;
      this.updateMilestonesForLeg(leg);
    },
      addEwaybilldoc() {
      this.selectedLegId = this.tripDetails.leg_id;
      this.showTripPodDialog = true;
    },
    showLogs() {
      this.showTripLogs = true;
    },
    openChecklist() {
      this.showTripChecklistForm = true;

      const isSubmitted = this.tripDetails.is_checklist_submitted === "Yes";
      const isPassed = this.tripDetails.is_checklist_passed === "Yes";

      if (!isSubmitted) {
        // Checklist not submitted yet
        this.getChecklistData();
        this.getTripDetails(this.$route.params.id);
      } else if (isSubmitted && !isPassed) {
        // Checklist submitted, but not passed yet → fetch defects
        this.getDefectAssetChecklistData();
        this.getTripDetails(this.$route.params.id);
      }
    },

    onLegChange(legId) {
      this.selectedLeg = this.triplegs.find((leg) => leg.id === legId);
      if (this.selectedLeg) {
        this.updateMilestonesForLeg(this.selectedLeg);
      }
    },
    viewTripDetails(id) {
      this.$router.push({
        path: `/app/admin/trip/details/${id}`,
        query: { backRoute: `/app/admin/trip/list` },
      });
      setTimeout(() => {
        this.permissions = getPermissions("leg_trip");
        this.getTripDetails(this.$route.params.id);
        this.getTripMatrixData(this.$route.params.id);
      }, 20);
    },
    getNextPreviousTrip(changeKey) {
      this.$bus.$emit("showLoader", true);
      let payload = {
        id: this.tripDetails.id,
        trip_change: changeKey,
      };
      this.$api.trip
        .prevNextTrip(payload)
        .then((res) => {
          this.viewTripDetails(res.data.trip_id);
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Trip not found!",
            color: "error",
          });
        });
    },
    goToDriverList() {
      this.$router.push("/app/admin/asset-management/driver/list");
    },
    goToVehicleList() {
      this.$router.push("/app/admin/asset-management/vehicle/list");
    },
    goToTrailerList() {
      this.$router.push("/app/admin/asset-management/trailer/list");
    },
    async getTripLegDetail() {
      this.$bus.$emit("showLoader", true);
      await this.$api.trip
        .getTripLegDetails(this.$route.params.id)
        .then((res) => {
          this.triplegs = res.data;
          // Set default selected leg to first leg
          // if (res.data.length > 0) {
          //   this.selectedLegId = res.data[0].id;
          //   this.selectedLeg = res.data[0];
          //   this.updateMilestonesForLeg(res.data[0]);
          // }
          if (res.data.length > 0) {
            if (!this.selectedLegId) {
              // First time loading - select first leg
              this.selectedLegId = res.data[0].id;
              this.selectedLeg = res.data[0];
            } else {
              // Maintain current selection but update the leg data
              const currentLeg = res.data.find(
                (leg) => leg.id === this.selectedLegId,
              );
              if (currentLeg) {
                this.selectedLeg = currentLeg;
              } else {
                // If previously selected leg doesn't exist, select first one
                this.selectedLegId = res.data[0].id;
                this.selectedLeg = res.data[0];
              }
            }
            this.updateMilestonesForLeg(this.selectedLeg);
          }

          this.$bus.$emit("showLoader", false);
        })

        .catch((err) => {
          if (err && err.data) {
            const showToast = (message) => {
              this.$bus.$emit("showToastMessage", {
                message,
                color: "error",
                hasActions: true,
              });
            };

            if (err.data.message) {
              showToast(err.data.message);
            } else if (
              err.data.error &&
              err.data.error.non_field_errors &&
              err.data.error.non_field_errors.length
            ) {
              showToast(err.data.error.non_field_errors.join(", "));
            } else {
              showToast("Fetch Trip Details Failed");
            }
          }
          this.$bus.$emit("showLoader", false);
        });
    },
    refreshCalls() {
      console.error("No");
    },
    updateMilestonesForLeg(leg) {
      if (!leg) {
        console.log("No leg provided");
        return;
      }

      this.selectedLeg = leg;

      if (leg.trip_milestones && leg.trip_milestones.length > 0) {
        leg.trip_milestones.sort((a, b) => a.sequence - b.sequence);
      }
    },
    updateTripSattus() {
      this.$bus.$emit("showLoader", true);

      this.$api.trip
        .startTrips({
          id: this.tripDetails.id,
          data: {
            remarks: null,
            status: "Active",
          },
        })
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Trip Status updated successfully!",
            color: "success",
          });
        })
        .catch((err) => {
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: `${
              err.data && err.data.error
                ? err.data.error
                : "Couldn't update trip timestamp"
            }`,
            color: "error",
          });

          this.formErrors = err.data;
        });
    },

    updateMilestone(id, trip, timestamp, name) {
      this.$bus.$emit("showLoader", true);
      let payload = {
        id: id,
        trip: trip,
        is_updated: true,
        milestone_name: name,
      };

      payload.timestamp = new Date();

      this.$api.tripCustomMilestone
        .updateTripMilestones({ id: id, data: payload })
        .then((res) => {
          this.$bus.$emit("showLoader", false);
          this.getTripDetails(this.$route.params.id);
          this.getTripLegDetail();

          let message = res?.data?.message;
          if (message) {
            this.$bus.$emit("showToastMessage", {
              message: "Trip Milestone updated successfully",
              color: "success",
            });
          } else {
            this.$bus.$emit("showToastMessage", {
              message: "Trip Milestone updated successfully",
              color: "success",
            });
          }
        })
        .catch((err) => {
          const milestone = this.selectedLeg.trip_milestones.find(
            (m) => m.id === id,
          );
          if (milestone) {
            milestone.is_updated = false;
          }
          this.formErrors = err.data;
          this.getTripDetails(this.$route.params.id);

          if (err && err.data) {
            const message = err.data[0] || err.data || "Something went wrong!";

            this.$bus.$emit("showToastMessage", {
              message: message,
              color: "error",
              hasActions: true,
            });
          }

          this.$bus.$emit("showLoader", false);
        });
    },

    callBackRoute() {
      this.$router.push("/app/admin/trip/list");
    },
    async getTripDetails(id) {
      this.$bus.$emit("showLoader", true);
      await this.$api.trip
        .getTripDetailsData(id)
        .then(async (res) => {
          this.tripDetails = res.data;
          this.getRoute();

          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    async getTripMatrixData(id) {
      await this.$api.trip
        .getTripMatrixData(id)
        .then((resp) => {
          this.driverLocationDetails = resp.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    updateMilestoneStatus(milestone, index) {
      // Update current milestone logic
      this.milestones.forEach((m, i) => {
        m.current = false;
      });

      // Find the first incomplete milestone and mark it as current
      const firstIncomplete = this.milestones.find((m) => !m.completed);
      if (firstIncomplete) {
        firstIncomplete.current = true;
      }
    },
    getAssetChecklistData(params = {}) {
      params = {
        limit: "all",
        // date: this.tripDetails.trip_date,
        // driver: this.tripDetails.driver,
        ...params,
      };

      this.$api.vehicle
        .getAssetChecklist(params)
        .then((res) => {
          this.checkList = res.data.flatMap((entry) => entry.items || []);

          this.showChecklistForm = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getDefectAssetChecklistData(params = {}) {
      params = {
        limit: "all",
        vehicle: this.tripDetails.vehicle,
        trailer: this.tripDetails.trailer,
        trailer2: this.tripDetails.trailer2,
        trip_id: this.tripDetails.id,
        checklist_submitted_on: this.tripDetails.checklist_submitted_on,
        ...params,
      };

      this.$api.vehicle
        .getDefectAssetChecklist(params)
        .then((res) => {
          this.defectCheckList = res.data.flatMap(
            (entry) => entry.defect_asset_checklist_items || [],
          );
          this.showChecklistForm = true;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async refreshTripDetails() {
      await this.getTripMatrixData(this.$route.params.id);
      await this.getTripDetails(this.$route.params.id);
    },
    getRoute() {
      // Ensure that trip details and trip_route_json are available
      if (this.tripDetails && this.tripDetails.trip_route_json) {
        if (this.directionsTimeout) {
          clearTimeout(this.directionsTimeout);
        }

        this.directionsTimeout = setTimeout(() => {
          const tripRoute = this.tripDetails.trip_route_json;
          const directions = [
            {
              name: "Route 1",
              distance: tripRoute.distance_in_km,
              route: tripRoute.planed_route,
            },
          ];

          this.loadRoute();
          this.loadMarkers();
        }, 200);
      }
    },

    loadRoute() {
      if (this.markerTimeout) {
        clearTimeout(this.markerTimeout);
      }
      this.markerTimeout = setTimeout(() => {
        // Use the first route provided by getDirections
        if (this.tripDetails.trip_route_json) {
          this.tripDetails = {
            ...this.tripDetails,
            route: this.tripDetails.trip_route_json.planed_route,
            distance: this.tripDetails.trip_route_json.distance_in_km,
          };

          // Add the planned route to the map
          this.$refs.transporterTripDetailsMap.addGeoCollection(
            this.tripDetails.route,
          );
        }

        // Add actual route if available
        if (
          this.driverLocationDetails &&
          this.driverLocationDetails.actual_route &&
          this.driverLocationDetails.actual_route.features &&
          this.driverLocationDetails.actual_route.features[0].properties
        ) {
          this.driverLocationDetails.actual_route.features[0].properties.actual_route = true;
          this.$refs.transporterTripDetailsMap.addGeoCollection(
            this.driverLocationDetails.actual_route,
            false,
          );
        }
      }, 500);
    },

    loadMarkers() {
      const markers = [
        { ...this.tripDetails.source_point, type: "source" },
        { ...this.tripDetails.destination_point, type: "destination" },
      ];
      if (this.tripDetails.mid_point && this.tripDetails.destination_point) {
        markers.push({ ...this.tripDetails.mid_point, type: "mid" });
      }

      if (
        this.driverLocationDetails &&
        this.driverLocationDetails.last_location &&
        this.driverLocationDetails.last_location.location
      ) {
        markers.push({
          ...this.driverLocationDetails.last_location.location,
          type: "truck",
          speed: this.driverLocationDetails.last_location.speed,
          device_id: this.driverLocationDetails.last_location.device_id,
          vehicle_id: this.driverLocationDetails.last_location.vehicle_number,
        });
      }

      this.$refs.transporterTripDetailsMap.addMultipleMarkers(markers);
    },
    updateTripRevertMilestone({ remarks }) {
      const payload = {
        ...this.milestonePayload,
        milestone_revert_remarks: remarks,
      };

      this.$api.tripCustomMilestone
        .revertTripMilestone(payload.id, payload)
        .then((response) => {
          this.$bus.$emit("showLoader", false);
          this.getTripDetails(this.$route.params.id);
          this.getTripLegDetail();

          this.showConfirmationDialog = false;
        })
        .catch((error) => {
          this.formErrors = error.data?.error || {};
          const showToast = (message) => {
            this.$bus.$emit("showToastMessage", {
              message,
              color: "error",
              hasActions: true,
            });
          };

          if (error?.data?.message) {
            showToast(error.data.message);
          } else if (error?.data?.error?.non_field_errors?.length) {
            showToast(error.data.error.non_field_errors.join(", "));
          } else {
            showToast("Trip Revert Failed");
          }

          this.getTripDetails(this.$route.params.id);
          this.getTripLegDetail();
          this.$bus.$emit("showLoader", false);
        });
    },
    revertTrip(milestoneId, sequence) {
      this.showConfirmationDialog = true;
      this.milestonePayload = {
        id: milestoneId,
        sequence: sequence,
      };
      this.status = "info";
      this.title = "Revert Milestone";
      this.text = "Are you sure you want to revert the Milestone?";
      this.icon = "mdi-information";
    },

    getChecklistData() {
      this.$api.trip
        .getTripNewCheckList(this.tripDetails.id)
        .then((res) => {
          this.checkList = res.data.check_list;
          this.showChecklistForm = true;

          for (let i = 0; i < this.checkList.length; i++) {
            if (
              this.checkList[i].is_checked == "Yes" &&
              this.checkList[i].is_mandatory == "No"
            ) {
              this.tripCheckListButton = true;
              return;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getStatusClass(status) {
      return {
        "status-active": status === "Active",
        "status-completed": status === "Completed",
        "status-pending": status === "Assigned",
      };
    },
    formatDate(dateStr) {
      return dateStr;
    },
    formatDateTime(dateTimeStr) {
      return dateTimeStr;
    },
  },

  async beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("leg_trip");
      const disableTimestamp = getPermissions(
        "update_odometer_and_triptimestamp",
      );
      if (!permissions || !permissions.change) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`,
        );
      } else {
        this.permissions = { ...permissions };
        this.disableTimestamp = { ...disableTimestamp };
        await this.getTripMatrixData(this.$route.params.id);
        await this.getTripDetails(this.$route.params.id);
        await this.getTripLegDetail(this.$route.params.id);
      }
    }
  },
};
</script>

<style scoped>
.trip-details {
  padding: 16px;
  background-color: #f5f5f5;
  min-height: 100vh;
  font-family: "Roboto", sans-serif;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: #666;
}

.back-btn:hover {
  background: #f0f0f0;
}

.arrow {
  font-size: 20px;
}

.trip-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #333;
}

.status-chip {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.status-active {
  background: #ff9800;
  color: rgb(225, 90, 11);
}

.status-completed {
  background: #4caf50;
  color: white;
}

.status-pending {
  background: #2196f3;
  color: white;
}

.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  position: relative;
  color: #666;
}

.icon-btn:hover {
  background: #f0f0f0;
}

.icon {
  font-size: 18px;
}

.badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ff5722;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation-btns {
  display: flex;
  gap: 8px;
  margin-left: 16px;
}

.nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  color: #2196f3;
  font-size: 20px;
}

.nav-btn:hover {
  background: #e3f2fd;
}

.header-right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.primary-btn {
  background: #ff5722;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}

.primary-btn:hover {
  background: #e64a19;
}

.upload-btn {
  background: #2196f3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
}

.upload-btn:hover {
  background: #1976d2;
}

.trip-info-section {
  background: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  justify-content: space-between;
}

.info-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Table Layout Version */
.trip-info-section-table {
  background: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.trip-info-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.trip-info-table th {
  background: #f8f9fa;
  color: #666;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

.trip-info-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 500;
  color: #333;
  vertical-align: middle;
}

.trip-info-table tr:last-child td {
  border-bottom: none;
}

.trip-info-table tr:nth-child(even) {
  background: #fafafa;
}

.trip-info-table tr:hover {
  background: #f5f5f5;
}

.edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #2196f3;
  font-size: 14px;
  padding: 2px 4px;
  border-radius: 2px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  margin-left: 8px;
}

.edit-btn:hover {
  background: #e3f2fd;
  opacity: 1;
}

@media (max-width: 768px) {
  .trip-info-table {
    font-size: 12px;
  }

  .trip-info-table th,
  .trip-info-table td {
    padding: 8px 12px;
  }
}

.info-item {
  text-align: center;
}

.label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  display: block;
  margin-bottom: 4px;
}

.value {
  font-weight: 500;
  margin: 0;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.divider {
  width: 1px;
  height: 40px;
  background: #e0e0e0;
}

.edit-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #2196f3;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 2px;
}

.edit-btn:hover {
  background: #e3f2fd;
}

.main-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 16px;
}

.map-section {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.map-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

.map-legend {
  display: flex;
  gap: 16px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.legend-dot.start {
  background: #4caf50;
}

.legend-dot.end {
  background: #f44336;
}

.legend-dot.current {
  background: #ff9800;
}

.map-container {
  height: 400px;
  background: #e3f2fd;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.map-placeholder {
  width: 100%;
  height: 100%;
  position: relative;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
}

.route-line {
  position: absolute;
  top: 20%;
  left: 10%;
  width: 75%;
  height: 50%;
  border: 3px solid #2196f3;
  border-radius: 0 0 50px 0;
  border-top: none;
  border-left: none;
}

.marker {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  z-index: 2;
}

.start-marker {
  background: #4caf50;
}

.current-marker {
  background: #ff9800;
}

.end-marker {
  background: #f44336;
}

.marker-label {
  position: absolute;
  top: 25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
}

.milestones-section {
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Leg Selection Styles */
.leg-selection {
  margin-bottom: 24px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.leg-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.leg-title {
  font-weight: 500;
  color: #333;
  font-size: 16px;
}

.leg-progress-text {
  color: #666;
  font-size: 14px;
  background: #fff;
  padding: 4px 8px;
  border-radius: 12px;
  border: 1px solid #ddd;
}

/* Milestones List Styles */
.milestones-list {
  margin-top: 16px;
}

.milestones-title {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.milestone-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.2s ease;
}

.milestone-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.milestone-checkbox {
  position: relative;
  margin-top: 4px;
}

.custom-checkbox {
  opacity: 0;
  position: absolute;
  width: 20px;
  height: 20px;
  margin: 0;
  cursor: pointer;
}

.checkbox-label {
  display: block;
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.custom-checkbox:checked + .checkbox-label {
  background: #4caf50;
  border-color: #4caf50;
}

.custom-checkbox:checked + .checkbox-label::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.milestone-content {
  flex: 1;
}

.milestone-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.milestone-icon {
  font-size: 16px;
}

.milestone-time {
  margin-left: auto;
  font-size: 12px;
  color: #666;
  font-weight: normal;
}

.milestone-description {
  margin: 0;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .main-content {
    grid-template-columns: 1fr;
  }

  .info-row {
    flex-direction: column;
    gap: 16px;
  }

  .info-group {
    flex-wrap: wrap;
    justify-content: center;
  }

  .header-section {
    flex-direction: column;
    gap: 12px;
  }

  .header-left {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
